import {Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation} from "@angular/core";
import {Subject, takeUntil} from "rxjs";
import {AppLayoutService} from "@core/services/app-layout.service";
import {AppService} from "@core/services/app.service";
import {NavService} from "@core/services/nav.service";
import {NavigationEnd, Router, RouterModule} from "@angular/router";
import { INavMenu, navItems} from "@layouts/components";
import {filter} from "rxjs/operators";
import {checkClickDuplicateMenu} from "@layouts/components/nav.util";
import {SCREEN_MAX_MOBILE, uriConsts} from "@shared/constants";
import {ImgCdnPipe} from "@shared/pipes/global";
import { isPlatformBrowser } from "@angular/common";
import {TranslocoModule} from "@jsverse/transloco";


@Component({
  selector: 'app-nav-vertical',
  templateUrl: './nav-vertical.component.html',
  styleUrls: ['./nav-vertical.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    RouterModule,
    TranslocoModule,
    ImgCdnPipe,
  ]
})
export class NavVerticalComponent implements OnInit, OnDestroy {
  readonly uriConsts = uriConsts;
  @Input() isHideCollapseMenu = false;

  private destroyed$ = new Subject();

  navItems: INavMenu[] = navItems;
  previousUrl: string = this.getPathName();
  currentUrl: string = this.getPathName();
  isLoader = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    public app: AppService,
    public appLayout: AppLayoutService,
    private router: Router,
    private navService : NavService,
  ) {
    const allowed = this.navService.navItemsAllows$.getValue();
    this.navItems = this.buildMenuState(allowed.length ? allowed : this.navItems);
  }

  ngOnInit() {
    this.navService.navItemsAllows$.pipe(takeUntil(this.destroyed$)).subscribe(items => {
      this.navItems = this.buildMenuState(items);
    });
    this.router.events
      .pipe(takeUntil(this.destroyed$))
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe({
        next: () => {
          this.previousUrl = this.currentUrl;
          this.currentUrl = this.getPathName();
          if (this.previousUrl != this.currentUrl) {
            this.isLoader = true;
            this.navItems = this.buildMenuState(this.navItems);
            setTimeout(() => this.isLoader = false);
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(null);
    this.destroyed$.complete();
  }

  getPathName() {
    if (isPlatformBrowser(this.platformId)) {
      return window.location.pathname
    }
    return '';
  }

  private buildMenuState(navItems: INavMenu[]): INavMenu[] {
    return navItems.map(item => this.buildMenuItemState(item));
  }

  private buildMenuItemState(item: INavMenu): INavMenu {
    const children = item.children?.map(child => this.buildMenuItemState(child));
    const active = item.url === this.currentUrl || !!children?.some(child => child.active);

    return {
      ...item,
      active,
      children
    };
  }


  onHandleClick(url?: string) {
    if (url) {
      checkClickDuplicateMenu(url, this.app)
    }

    if (this.appLayout.screenWidth && this.appLayout.screenWidth < SCREEN_MAX_MOBILE) {
      this.appLayout.isOpenNavMobile = false;
    }
  }


}
